<template>
  <div
    class="content-devx"
  >
    <f7-row no-gap>
      <f7-col width="50">
        <DxForm
          id="mainData-form"
          :show-colon-after-label="true"
          :read-only="readOnly"
        >
          <DxGroupItem>
            <DxSimpleItem
              name="date"
              :data-field="$t('Searcher.observations.date')"
              editor-type="dxDateBox"
              :editor-options="{
                onValueChanged: onChangeDate,
                width: 250,
                value: currentValuesMainData.date,
                displayFormat: 'dd/MM/yyyy',
                invalidDateMessage: $t('dates_isInvalid'),
                onInitialized:init,
                pickerType: 'calendar',
              }"
            >
              <DxRequiredRule :message="$t('Searcher.observations.dateValidation')" />
            </DxSimpleItem>
            <DxSimpleItem
              name="geolocation"
              :data-field="$t('Searcher.observations.geolocation')"
              editor-type="dxSelectBox"
              :editor-options="{
                items: scoutingPoints,
                onValueChanged: onGeolocationChange,
                value: currentValuesMainData.idGeolocationPoint,
                displayExpr: 'name',
                valueExpr: 'id',
                width: 250,
                searchEnabled: true,
                searchTimeout: searchTimeoutOption,
                minSearchLength: minSearchLengthOption,
                showDataBeforeSearch: showDataBeforeSearchOption,
              }"
            >
              <DxRequiredRule :message="$t('Searcher.observations.geolocationValidation')" />
            </DxSimpleItem>
            <DxSimpleItem
              name="category"
              :data-field="$t('Searcher.observations.category')"
              editor-type="dxSelectBox"
              :editor-options="{
                items: categoriesOfTemplates,
                onValueChanged: onCategoryChange,
                value: currentValuesMainData.category,
                searchEnabled: true,
                width: 250,
                searchTimeout: searchTimeoutOption,
                minSearchLength: minSearchLengthOption,
                showDataBeforeSearch: showDataBeforeSearchOption,
              }"
            >
              <DxRequiredRule :message="$t('Searcher.observations.categoryValidation')" />
            </DxSimpleItem>
            <DxSimpleItem
              name="subcategory"
              :data-field="$t('Searcher.observations.subcategory')"
              editor-type="dxSelectBox"
              :editor-options="{
                items: templatesByCategory,
                onValueChanged: onSubcategoryChange,
                value: currentValuesMainData.subcategory,
                displayExpr: 'subcategory',
                valueExpr: 'id',
                searchEnabled: true,
                width: 250,
                searchTimeout: searchTimeoutOption,
                minSearchLength: minSearchLengthOption,
                showDataBeforeSearch: showDataBeforeSearchOption,
              }"
            >
              <DxRequiredRule :message="$t('Searcher.observations.subcategoryValidation')" />
            </DxSimpleItem>
          </DxGroupItem>
        </DxForm>
      </f7-col>
      <f7-col width="50">
        <DxForm
          v-if="!readOnly"
          id="form"
          :show-colon-after-label="false"
        >
          <DxSimpleItem
            data-field=""
            :editor-options="{
              disabled: true,
              height: 41
            }"
          />
          <DxButtonItem
            :button-options="addGeolocationPoint"
            :horizontal-alignment="isMobile ? 'center' : 'left'"
          />
        </DxForm>
      </f7-col>
    </f7-row>
  </div>
</template>

<script>
import moment from 'moment';
import {
  DxForm,
  DxSimpleItem,
  DxRequiredRule,
  DxGroupItem,
  DxButtonItem,
} from 'devextreme-vue/form';
import { mapActions, mapState } from 'vuex';
import { Device } from 'framework7/framework7-lite.esm.bundle';

export default {
  name: 'MainData',
  components: {
    DxForm,
    DxSimpleItem,
    DxRequiredRule,
    DxGroupItem,
    DxButtonItem,
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
    companyId: {
      type: String,
      default: '',
    },
    plantationId: {
      type: String,
      default: '',
    },
    scoutingPoints: {
      type: Array,
      default: () => [],
    },
    categoriesOfTemplates: {
      type: Array,
      default: () => [],
    },
    templatesByCategory: {
      type: Array,
      default: () => [],
    },
    currentValuesMainData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      searchTimeoutOption: 200,
      minSearchLengthOption: 0,
      showDataBeforeSearchOption: false,
      addGeolocationPoint: {
        icon: 'add',
        type: 'default',
        onClick: () => {
          this.$f7.views.main.router.navigate('/createObservationPoint/', { reloadCurrent: true });
        },
      },
      isMobile: Device.cordova,
    };
  },
  computed: {
    ...mapState('Plantation', ['currentPlantation']),
  },
  methods: {
    init(e) {
      e.component.option('calendarOptions',
        {
          cellTemplate: (args, itemIndex, itemElement) => {
            const actualDate = moment(args.date, 'YYYY-MM-DD');
            const initDate = moment(this.currentPlantation.initDate, 'YYYY-MM-DD');
            const endDate = moment(this.currentPlantation.endDate, 'YYYY-MM-DD');

            if (args.view === 'month') {
              if (actualDate.isBetween(initDate, endDate, 'days', '[]')) {
                return `<div style='color: #16a34a;'>${args.text}</div>`; 
              }
            }

            if (args.view === 'year') {
              if (actualDate.isBetween(initDate, endDate, 'months', '[]')) {
                return `<div style='color: #16a34a;'>${args.text}</div>`; 
              }
            }

            if (args.view === 'decade') {
              if (actualDate.isBetween(initDate, endDate, 'years', '[]')) {
                return `<div style='color: #16a34a;'>${args.text}</div>`; 
              }
            }

            if (args.view === 'century') {
              const exactYear = parseInt(actualDate.year() / 10) * 10;
              const initDateIsBetween = initDate.year() >= exactYear && initDate.year() <= exactYear + 9;
              const endDateIsBetween = endDate.year() >= exactYear && endDate.year() <= exactYear + 9;

              if ((initDateIsBetween || endDateIsBetween)) {
                return `<div style='color: #16a34a;'>${args.text}</div>`;
              }
            }
            return args.text;
          },

        });
    },
    async updateCurrentScoutingPoint(scoutingPointId) {
      if (scoutingPointId !== '') {
        this.$f7.preloader.show();
        try {
          await this.fetchCurrentScoutingPoint({ companyId: this.companyId, scoutingPointId });
        } catch (error) {
          this.$f7.dialog.alert(this.$t(`${error}`));
        } finally {
          this.$f7.preloader.hide();
        }
      }
    },
    onChangeDate(e) {
      this.setDate(e.value);
      this.setConfirmedDate(false);
    },
    onGeolocationChange(e) {
      this.resetCurrentScoutingPoint();
      this.updateCurrentScoutingPoint(e.value);
      this.setGeolocation(e.value);
    },
    async onCategoryChange(e) {
      if (e.event) {
        if (typeof e.value !== 'undefined' && e.value !== '') {
          try {
            this.setTemplateValue({});
            this.setCategory(e.value);
            this.setShowTemplateForm(false);
            await this.getTemplatesByCategory(e.value);
          } catch (error) {
            this.$f7.dialog.alert(this.$t(`${error}`));
          }
        }
      }
    },
    async onSubcategoryChange(e) {
      if (e.event) {
        if (typeof e.value !== 'undefined' && e.value !== '') {
          try {
            this.setTemplateValue({});
            this.setSubCategory(e.value);
            await this.getTemplateById(e.value);
          } catch (error) {
            this.$f7.dialog.alert(this.$t(`${error}`));
          }
        }
      }
    },
    ...mapActions('SearcherObservations', ['resetCurrentScoutingPoint', 'setDate', 'setGeolocation', 'setCategory', 'setSubCategory', 'getTemplatesByCategory', 'getTemplateById', 'setShowTemplateForm', 'fetchCurrentScoutingPoint', 'setTemplateValue', 'setConfirmedDate']),
  },
};
</script>

<style lang="scss" scoped>
@import './MainData.styles.scss';
</style>
